import { makeAutoObservable, runInAction } from 'mobx';
import { v4 } from 'uuid';
import type { ResponseDataRow } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';

import { cmApi } from '@src/api';
import { preloaderStore } from '@stores/preloaderStore';
import type { CmApi, CompanyDto } from '@src/api';

type CompanyDtoDefId = CompanyDto & { id: string };

export const TABS = {
  COMPANIES_CM: 'companiesCM',
  COUNTERPARTIES: 'counterparties',
};

class CounterpartiesStore {
  counterparties: CompanyDtoDefId[] = [];

  tab = TABS.COMPANIES_CM;

  organization: string | undefined = undefined;

  api: CmApi;

  checked: ResponseDataRow[] = [];

  isChanged = false; // флаг, что справочник изменился для проверки загрузки в fetchReferences

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  setTab = (value: string) => {
    this.tab = value;
  };

  setIsChanged = (value: boolean) => {
    this.isChanged = value;
  };

  setChecked = (value) => {
    this.checked = value;
  };

  setOrganization = (organization?: string) => {
    this.organization = organization;
  };

  fetch = async (counterparty = false): Promise<void> => {
    preloaderStore.preloader(true);
    const { data } = await this.api.companies.getCompanies({ counterparty });
    if (data) {
      runInAction(() => {
        this.counterparties =
          data?.map((item) => ({ ...item, id: v4(), counterparty: !item?.counterpartyFirstName })) ?? [];
        this.isChanged = false;
      });
    }
    preloaderStore.preloader(false);
  };

  fetchByParentCode = async (code: string, signal?: AbortSignal) => {
    const { data } = await this.api.companies.getAvailableCompaniesByCode(code, { signal });
    return data.map((item) => ({ ...item, id: item.code }));
  };

  groupDelete = async (rows: CompanyDto[]) => {
    preloaderStore.preloader(true, 'удаление...');
    const promises = rows.map((item) => this.api.companies.deleteCompany(item));
    await Promise.all(promises);
    await this.fetch();
    preloaderStore.preloader(false);
  };

  clear = () => {
    this.checked = [];
    this.tab = TABS.COMPANIES_CM;
    this.organization = undefined;
  };
}

export const counterpartiesStore = new CounterpartiesStore({ api: cmApi });
